import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal, Form, Button, Toast } from "react-bootstrap";
import dictionary from "../PL.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import SimpleSelect from "./common/simpleSelect";
import IntegrationAnnouncementService from "../services/integrationAnnouncementService";
import { toast } from "react-toastify";

const AddVirtualModuleModal = ({ show, onHide, vm, files, onSubmit }) => {
  const isEdit = vm !== null;

  const [editedVM, setEditedVM] = useState({
    name: "",
    file: { _id: "" },
    zones: [],
    interval: 10,
    active: false,
  });

  const [errors, setErrors] = useState({
    name: false,
    file: false,
    zones: false,
    interval: false,
    active: false,
  });

  function handleShow() {
    if (vm === null) {
      setEditedVM({
        id: null,
        name: "",
        zones: [],
        file: { _id: "" },
        interval: 10,
        active: false,
      });
    } else {
      setEditedVM({
        id: vm.id,
        name: vm.name,
        zones: vm.zones,
        file: { ...vm.file },
        interval: vm.interval,
        active: vm.active,
      });
    }

    // setErrors({
    //   name: false,
    //   devices: false,
    //   zones: false,
    //   file: false,
    // });
  }

  function verifyForm() {
    let verifiedErrors = {
      name: editedVM.name.length < 1,
      file: editedVM.file._id === "",
      zones: editedVM.zones.length === 0,
      interval: editedVM.interval === 0,
      active: editedVM.active === false,
    };
    setErrors(verifiedErrors);

    if (
      verifiedErrors.name ||
      verifiedErrors.file ||
      verifiedErrors.zones ||
      verifiedErrors.interval ||
      verifiedErrors.active
    ) {
      return false;
    }
    return true;
  }

  useEffect(() => {
    verifyForm();
  }, [editedVM]);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      let newVM = { ...editedVM };
          

      // newVM.fileId = newVM.file._id;
      if (newVM.id !== null && newVM.id !== undefined) {
        // update
        onSubmit(newVM);
      } else if (newVM.id === 0) {
        // add
        newVM.id = null; // reset id for new VM
      }
      toast.success("Zapisano");
      onHide();
    } catch (err) {
      console.log(err);
      toast.error("Błąd komunikacji z serwerem");
    }
  }

  function handleNameEdit(e) {
    setEditedVM({ ...editedVM, name: e.target.value });
  }

  function handleFileChange(fileId) {
    if (fileId === "") {
      setEditedVM({ ...editedVM, file: { _id: "" } });
      return;
    }

    const file = files.find((file) => file._id === fileId);
    setEditedVM({ ...editedVM, file: file });
  }

  function handleRemoveZone(zone) {
    // let index = editedVM.devices.findIndex((dev) => dev !== device);
    let modifiedVM = null;
    if (editedVM?.zones.includes(zone)) {
      const newZones = editedVM.zones.filter((dev) => dev !== zone);
      modifiedVM = { ...editedVM, zones: newZones };
    } else {
      const newZones = [...editedVM.zones, zone];
      modifiedVM = { ...editedVM, zones: newZones };
    }

    setEditedVM(modifiedVM);
  }

  const handleIntervalChange = (value) => {
    if (value < 3 || value > 12 * 60) {
      setErrors({ ...errors, interval: true });
    } else {
      setErrors({ ...errors, interval: false });
    }
    setEditedVM({ ...editedVM, interval: Number(value) });
  };

  return (
    <Modal
      show={show}
      onShow={handleShow}
      onEntering={handleShow}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {isEdit
              ? dictionary.integration.tabs_announcements.addEditModal.title_edit
              : dictionary.integration.tabs_announcements.addEditModal.title_add}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          {/* {this.renderInput("name", "Nazwa:")}
    
                {this.renderInput("description", "Opis:")} */}
          <Form.Group
            className="mb-3"
            controlId="name"
          >
            <Form.Label>Nazwa:</Form.Label>
            <Form.Control
              type="text"
              value={editedVM?.name}
              placeholder="Wprowadź nazwę"
              onChange={handleNameEdit}
              isValid={editedVM?.name && !errors.name}
              isInvalid={errors.name}
            />
          </Form.Group>

          <Form.Group
            className="mb-3"
            controlId="file"
          >
            <Form.Label>Plik:</Form.Label>
            <Form.Control
              as="select"
              value={editedVM?.file._id}
              onChange={(e) => handleFileChange(e.target.value)}
              style={{ borderColor: errors.file ? "red" : "" }}
              isValid={editedVM?.file._id && !errors.file}
              isInvalid={errors.file}
            >
              <option value={""}>Wybierz plik</option>
              {files.map((file) => (
                <option
                  key={file._id}
                  value={file._id}
                >
                  {file.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <hr></hr>
          <div className="mt-3 flex-container flex-container__column flex-container__center flex-container__space-between">
            <Form.Label>Strefy:</Form.Label>
            <div className="tag-container flex-container__center">
              {[1, 2, 3].map((zone) => {
                let className = "selectable-tag__name__notSelected";
                if (editedVM?.zones.includes(zone)) {
                  className = "selectable-tag__name";
                }

                return (
                  <div
                    className="tag"
                    key={zone + "-zone"}
                    onClick={() => handleRemoveZone(zone)}
                    style={{ borderColor: errors.zones ? "red" : "", borderWidth: errors.zones ? "1px" : "2px" }}
                  >
                    <div className={className}>{dictionary.integration.tabs_announcements.zoneMASettings[zone]}</div>
                  </div>
                );
              })}
            </div>
          </div>
          <Form.Group
            className="mb-3 mt-3"
            controlId="interval"
          >
            <Form.Label>Częstotliwość [minuty]:</Form.Label>
            <Form.Control
              type="number"
              value={editedVM?.interval}
              placeholder="Wprowadź częstotliwość"
              onChange={(e) => handleIntervalChange(e.target.value)}
              isValid={editedVM?.interval && !errors.interval}
              isInvalid={errors.interval}
              min={3}
              max={12 * 60}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={onHide}
            variant="primary"
          >
            Anuluj
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={errors.name || errors.file || errors.devices || errors.zones}
          >
            {isEdit ? "Edytuj" : "Dodaj"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddVirtualModuleModal;
